import { computed } from 'vue';
import { useAccountingStore } from '@/stores/accounting';
import USER_PERMISSIONS from '@/utils/constants/accounting/permissions_aliases';

export function useVendorsMenuItem() {
    const acctStore = useAccountingStore();

    const hasAccessToVendorsSection = computed(() => {
        return acctStore.hasPermission(USER_PERMISSIONS.ACCT_MANAGE_VENDORS);
    });

    const vendorsMenuItems = computed(() => ({
        list: [
            {
                id: '__vendors',
                label: 'Vendors',
                permissionChecker: hasAccessToVendorsSection.value,
                items: [
                    {
                        icon: 'shopping-bag',
                        label: 'Manage vendors',
                        id: 'vendor.manage_vendors',
                    },
                ],
            },
        ],
    }));

    return { vendorsMenuItems };
}
